import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    async gerarPdfMemoriaCalculo(memoriaCalculoDto) {
        try {
            const response = await axiosJwt.post(`${api}/relatorios/memoria-calculo`, memoriaCalculoDto, {
                responseType: 'blob'
            })
            return response.data
        } catch (error) {
            if (error.response && error.response.data instanceof Blob) {
                const text = await error.response.data.text()
                try {
                    const jsonError = JSON.parse(text)
                    error.response.data = jsonError
                } catch (e) {
                    error.response.data = { message: text }
                }
            }
            throw error
        }
    },

    async uploadMemoriaCalculoArquivo(uploadDto) {
        try {
            const response = await axiosJwt.post(`${api}/fornecedor/contratos/upload-arquivo`, uploadDto)
            return response.data
        } catch (error) {
            if (error.response && error.response.data instanceof Blob) {
                const text = await error.response.data.text()
                try {
                    const jsonError = JSON.parse(text)
                    error.response.data = jsonError
                } catch (e) {
                    error.response.data = { message: text }
                }
            }
            throw error
        }
    },

    async atualizarItemBoletimMedicao(contratoId, boletimMedicaoId, itemBoletimMedicaoId, dados) {
        try {
            const response = await axiosJwt.put(
                `${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/itens-medicao/${itemBoletimMedicaoId}`,
                dados
            )
            return response.data
        } catch (error) {
            throw error
        }
    },

    async adicionarAnexoItem(contratoId, boletimMedicaoId, itemBoletimMedicaoId, formData) {
        try {
            const response = await axiosJwt.post(
                `${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/itens-medicao/${itemBoletimMedicaoId}/anexos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            return response.data
        } catch (error) {
            throw error
        }
    },

    async excluirAnexoItem(contratoId, boletimMedicaoId, itemBoletimMedicaoId, anexoId) {
        try {
            const response = await axiosJwt.delete(
                `${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/itens-medicao/${itemBoletimMedicaoId}/anexos/${anexoId}`
            )
            return response.data
        } catch (error) {
            throw error
        }
    },

    async editarAnexoItem(contratoId, boletimMedicaoId, itemBoletimMedicaoId, anexoId, dados) {
        try {
            const response = await axiosJwt.patch(
                `${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/itens-medicao/${itemBoletimMedicaoId}/anexos/${anexoId}`,
                dados
            )
            return response.data
        } catch (error) {
            throw error
        }
    }
}
